module.exports = __webpack_public_path__ + "img/d636845cd5a22e0aa54766f2027897df.png";